import { useState } from "react";
import style from "./style.module.scss";
import ModalCustom from "../Modal/modal-template-default";

export default function Ad() {
  const [adOpen, setadOpen] = useState(true);
  const onHide = () => {
    setadOpen(false);
  };
  return <></>;
  return (
    <ModalCustom show={adOpen} onHide={onHide} className={style.ad} centered>
      <ModalCustom.Header className={style.header}></ModalCustom.Header>
      <ModalCustom.Body className={style.body}>
        <a href="https://www.nivelsuperior.com.br/eaiformou/" target="_blank">
          <img src="https://www.nivelsuperior.com.br/assets/img/E-AI-FORMOU_POP-UP.png" />
        </a>
      </ModalCustom.Body>
    </ModalCustom>
  );
}
